// extracted by mini-css-extract-plugin
export default {"AccountDetails":"AccountDetails_AccountDetails__-01ql","AccountDetailsActions":"AccountDetails_AccountDetailsActions__g5cpx"};